import { useEffect, useLayoutEffect } from 'react';

const useIsoLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// Marks the root with `motion-ready` (so CSS may hide content until it is revealed) and adds
// `is-inview` once to every `[data-inview]` element inside it the first time it enters the viewport.
const useInViewOnce = (ref, { threshold = 0.15, rootMargin = '0px 0px -8% 0px' } = {}) => {
    useIsoLayoutEffect(() => {
        const root = ref.current;
        if (!root) return undefined;
        const targets = [...root.querySelectorAll('[data-inview]')];

        if (!('IntersectionObserver' in window)) return undefined; // content simply stays visible
        root.classList.add('motion-ready');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-inview');
                observer.unobserve(entry.target);
            });
        }, { threshold, rootMargin });
        targets.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, [ref, threshold, rootMargin]);
};

export default useInViewOnce;
